// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1so9s","modalFooterButton":"ModalNotes_modalFooterButton__3WSQo"};